const integrationsInit = () => {
  const mainPattern = document.querySelector('.gg-integrations');

  if (!mainPattern) {
    return;
  }

  const itemTabContent = mainPattern.querySelectorAll('.wp-block-statik-tab');

  itemTabContent.forEach((item)=> {
    const integrationsBox = item.querySelectorAll('.gg-integrations-box');
    integrationsBox.forEach((box, index) => {
      box.classList.add('fade-in-up', `delay-01-${index}`);
    });
  })

  const handleCheckDataAnimatedSection = () => {
    itemTabContent.forEach((item)=> {
      const animatedSection  = item.querySelector('.gg-swiper-features');
      animatedSection.dataset.animatedSection = false;
      setTimeout(() => {
        if (item.classList.contains('wp-block-statik-tab--selected')) {
            animatedSection.dataset.animatedSection = true;
        }
      }, 150);

    })
  }

  const tabs = mainPattern.querySelectorAll('.wp-block-statik-tabs__nav-item');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      handleCheckDataAnimatedSection();
    });
  });
};

integrationsInit();
